<template>
  <div class="szw-flex szw-gap-2 szw-flex-1">
    <div :class="teamFormItemClasses" v-for="event in props.teamEvents" :key="event.eventId">
      <div :class="['szw-row__center szw-text-sm szw-rounded szw-w-5 szw-h-5 szw-text-white', getColorClass(event.status)]">
        <span>{{ event.status }}</span>
      </div>

      <img v-if="isTeamLogoVisible(event)" class="szw-w-5 szw-h-5" :src="event.against.logoUrl" alt="team-logo" />
      <FallbackLogo v-else-if="event.type !== 'shadow-event'" :text="getTeamInitial(event)" />
      <span v-else class="szw-font-semibold">-</span>
    </div>
  </div>
</template>

<script setup>
import FallbackLogo from '@/__core__/components/FallbackLogo.vue'
import { computed } from 'vue'

const props = defineProps({
  teamEvents: {
    type: Array,
    default: () => []
  },
  isSmallWidgetContainerSize: {
    type: Boolean,
    default: false
  },
  activeTheme: {
    type: String,
    default: 'light'
  }
})

const baseClasses = ['szw-col szw-items-center first:szw-ml-auto last:szw-mr-auto']
const teamFormItemClasses = computed(() => [...baseClasses, props.isSmallWidgetContainerSize ? 'szw-gap-2' : 'szw-gap-4'])

const isTeamLogoVisible = (event = null) => {
  if (!event) {
    return false
  }

  return event?.against?.logoUrl
}

/**
 * @param { 'L' | 'D' | 'W' | '' } formStatus
 * @returns { 'szw-bg-lose' | 'szw-bg-draw' | 'szw-bg-win' | 'szw-bg-disable-light' | 'szw-bg-disable-dark }
 **/
const getColorClass = (formStatus = '') =>
  ({
    L: 'szw-bg-lose',
    D: 'szw-bg-draw',
    W: 'szw-bg-win'
  }[formStatus] || `szw-bg-disable-light`)

/**
 * @param {{ against: { name: string, shortName: string, logoUrl: string } }} event
 * @returns { string }
 */
const getTeamInitial = (event = {}) => event.against?.shortName || ''
</script>
